import { useEffect, useMemo, useState } from 'react';
import getElementOffsetTop from '@/vdp/DesktopPageNavigation/getElementOffsetTop';
import debounce from '~/utilities/debounce';

const useCurrentSection = topOffset => {
  const [currentSection, setCurrentSection] = useState('');

  const setCurrentNavTabBasedOnScroll = useMemo(
    () =>
      debounce(() => {
        const scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        const scrollSection = [
          ...document.querySelectorAll<HTMLElement>('[data-nav-section]')
        ].reduce((acc, section) => {
          const sectionTop = getElementOffsetTop(section);
          if (
            scrollTop >= sectionTop - topOffset &&
            scrollTop <= sectionTop + section.getBoundingClientRect().height
          ) {
            return section.dataset.navSection || '';
          }

          return acc;
        }, '');

        setCurrentSection(scrollSection);
      }, 50),
    [topOffset]
  );

  useEffect(() => {
    window.addEventListener('scroll', setCurrentNavTabBasedOnScroll);

    return () => {
      window.removeEventListener('scroll', setCurrentNavTabBasedOnScroll);
    };
  }, [setCurrentNavTabBasedOnScroll]);

  return currentSection;
};

export default useCurrentSection;
